export const SHOW_LANDING_FORM_PAGE = 'events/SHOW_LANDING_FORM_PAGE';

/**
 * @return {{type: string}}
 */
export const showLandingFormPage = (show) => ({
  type: SHOW_LANDING_FORM_PAGE,
  payload: show,
});
